var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVtA(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5466 62.4134C23.5551 59.8735 28.9965 55.5556 34.6935 58.6035C41.8147 62.4134 42.3625 70.0331 40.1713 73.843C37.9802 77.6529 29.2156 80.9185 24.2855 76.5644C20.3414 73.081 19.9657 70.1337 20.3309 67.9566",
    stroke: "#9E9C9A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9059 58.3641C69.87 58.5713 67.47 64.5676 67.0246 67.5399L67.6567 70.6691C68.3742 72.5854 71.0136 76.6574 75.8315 77.6155C81.854 78.8131 87.437 72.1138 87.4393 68.0379C87.4416 63.962 83.4507 58.1052 75.9059 58.3641Z",
    stroke: "#9E9C9A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7777 68.4442C74.9259 63.7776 74.6666 55.222 73.1111 52.8887",
    stroke: "#9E9C9A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4445 54.4443C70.5185 53.148 76.0667 50.8665 81.6667 52.111C83.5334 50.2443 84 49.2591 84 48.9998C84 46.4072 81.5111 40.7553 71.5556 38.8887C79.3334 51.7836 46.6667 43.5553 45.8889 65.3331",
    stroke: "#9E9C9A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2222 62.9998C61.4445 63.7776 60.0445 65.9554 60.6667 68.4443C61.2889 70.9332 42.2593 69.9998 32.6667 69.2221C31.6296 67.6665 29.5555 62.5332 42 60.6665",
    stroke: "#9E9C9A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M56 63.7778L24.8889 46.6667C26.963 44.3333 32.5111 40.6 38.1111 44.3333",
    stroke: "#9E9C9A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2222 47.444L47.4444 51.3331M60.6666 44.333C55.9999 41.2218 51.3333 40.444 47.4444 45.1107",
    stroke: "#EF533F",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVtA);
export default __webpack_public_path__ + "static/media/vt_a.c19117952c08cf5a24fbc24996659c61.svg";
export { ForwardRef as ReactComponent };